// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"4fa5fa15","121":"92c388ab","129":"952f99f5","137":"6fee8c8a","189":"d96b0454","214":"34c6b41c","395":"a1745861","524":"e3592a69","527":"98c9f6f3","710":"96972fda","942":"346008f9"}[chunkId] + ".chunk.js";
};